import { ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@eo/shared';

import { meetingOutcomeLabel } from './helpers';
import type { MeetingsProcessedProps } from './types';

export function MeetingsProcessed({ meetings }: MeetingsProcessedProps) {
  if (meetings.length === 0) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex h-8 items-center gap-2 rounded-8 border border-control-border bg-control px-3 text-sm text-control-foreground transition-colors hover:bg-control-hover focus-visible:border-focus focus-visible:outline-none"
        >
          Meetings ({meetings.length})
          <ChevronDown className="size-4 shrink-0 text-control-placeholder" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-1">
        <ul className="flex flex-col divide-y divide-border-faint">
          {meetings.map((meeting) => (
            <li
              key={meeting.noteId}
              className="flex flex-col px-2 py-2 text-sm transition-colors hover:bg-control-hover"
            >
              <span className="font-medium text-text-primary">{meeting.title}</span>
              <span className="text-xs text-text-tertiary">
                {meeting.client ? `${meeting.client} · ` : ''}
                <span>{meetingOutcomeLabel(meeting)}</span>
              </span>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
